import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import api from '../../services/api';

export default function AutoLoginPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    const tenantId = searchParams.get('tenant_id');
    const timezone = searchParams.get('timezone');
    if (token && tenantId) {
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      const authState = {
        token,
        userId: null,
        username: 'admin',
        role: 'admin',
        tenantId: parseInt(tenantId, 10),
        isSuperadmin: true,
        mustChangePassword: false,
        tenantTimezone: timezone || 'America/Chicago',
      };
      localStorage.setItem('auth', JSON.stringify(authState));
      window.location.href = '/';
    } else {
      navigate('/login');
    }
  }, [searchParams, navigate]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
      <CircularProgress sx={{ mb: 2 }} />
      <Typography>Logging in...</Typography>
    </Box>
  );
}
